





































import { Component, Watch, Prop, InjectReactive } from "vue-property-decorator";
import ModulesSet from "./ModulesSet.vue";
import ModulesPreview from "./ModulesPreview.vue";
import ModulesConfig from "./ModulesConfig.vue";
import manualAddCpn from "../questionBank/manualAddNew.vue";
import { mixins } from "vue-class-component";

import commonMixin from "@/mixins/commonNewMixins";
import { questionData, questionDataForReviews, questionDataForQAE, testData, QuestionDataType, literatureData } from "../../../../config/newQuestionnaire";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
import surveyTemplateSelectDialog from "./surveyTemplateSelectDialog.vue";
import DeduplicationClassDialog from "./deduplicationClassDialog.vue";
@Component({
  name: "questionnaireSet",
  components: {
    ModulesSet,
    ModulesPreview,
    ModulesConfig,
    manualAddCpn,
    surveyTemplateSelectDialog,
    DeduplicationClassDialog,
  },
  filters: {},
})
export default class questionnaireSet extends mixins(commonMixin) {
  @Prop({
    type: String,
    default: "ACTIVITY",
  })
  type?: string;
  @Prop({
    default: "ACTIVITY_INTERACT",
  })
  activityQuestionnaireProperty?: string;
  @InjectReactive()
  surveyType!: string; // 区分表单类型 undefind/NORMAL-正常表单创建 LITERATURE-文献表单创建（学术征集、病例PPT、医学讲堂）

  private cmpsData: QuestionDataType = []; // $ 基础组件
  dialogVisibleManualAddCpn = false;
  @Watch("questionnaireType", { deep: true, immediate: true })
  listenQuestionnaireType(newval: string) {
    // this.getData();
    console.log("questionnaireType", newval, this.surveyType);
    if (this.surveyType === "LITERATURE") {
      // 补充提交文献信息 问卷
      this.cmpsData = literatureData;
      return;
    }
    if (newval == "QUESTIONNAIRE") {
      if (this.activityQuestionnaireProperty == "REVIEWS") {
        this.cmpsData = JSON.parse(JSON.stringify(questionDataForReviews));
      } else if (this.activityQuestionnaireProperty == "DOCTOR_QUESTION" || this.activityQuestionnaireProperty == "EXPERT_ANSWER") {
        this.cmpsData = JSON.parse(JSON.stringify(questionDataForQAE));
      } else {
        this.cmpsData = JSON.parse(JSON.stringify(questionData));
      }
      // 预约组件目前仅针对报名前置收集 开放配置
      if (this.activityQuestionnaireProperty == "INFORMATION_COLLECTION") {
        const advanceArray = this.cmpsData.filter((item) => {
          return item.key === "advanceArray";
        })[0].questionItem;
        const componentNames = advanceArray.map((item) => item.componentName);
        // console.log("questionnaireType", componentNames);
        if (componentNames.includes(30)) {
          advanceArray.splice(componentNames.indexOf(30), 1);
        }
      }
      if (this.activityQuestionnaireProperty == "INFORMATION_COLLECTION") {
        const advanceArray = this.cmpsData.filter((item) => {
          return item.key === "advanceArray";
        })[0].questionItem;
        const componentNames = advanceArray.map((item) => item.componentName);
        // console.log("questionnaireType", componentNames);
        if (componentNames.includes(30)) {
          advanceArray.splice(componentNames.indexOf(30), 1);
        }
      }
    } else {
      this.cmpsData = testData;
    }
  }
  get answerItemList() {
    return this.dataList.filter((item) => {
      return [1, 2].includes(item.componentName);
    });
  }
  private get isConfigforAllShow() {
    return QuestionnaireEditModule.isConfigforAllShow;
  }
  private get isModel() {
    return QuestionnaireEditModule.isModel;
  }
  get isAnswerMode() {
    return this.questionnaireType == "ANSWER";
  }
  get questionnaireType() {
    return QuestionnaireEditModule.questionnaireType;
  }
  get dataList() {
    return QuestionnaireEditModule.dataList;
  }

  // 问卷排重
  private get participateRepeatedCheck() {
    return QuestionnaireEditModule.basicData.participateRepeatedCheck;
  }
  private get participateRepeatedClassId() {
    return QuestionnaireEditModule.basicData.participateRepeatedClassId;
  }
  private get participateRepeatedClassName() {
    return QuestionnaireEditModule.basicData.participateRepeatedClassName;
  }
  isRepeatedChange(val: boolean) {
    QuestionnaireEditModule.SET_BASIC_DATA_REPEATED(val);
    if (!val) {
      QuestionnaireEditModule.SET_BASIC_DATA_REPEATEDCLASSID("");
      QuestionnaireEditModule.SET_BASIC_DATA_REPEATEDCLASSNAME("");
    }
  }
  deduplicationClassDialogVisible = false;
  deduplicationClassMode = "SET";
  opendeDuplicationClassDialog(mode: string) {
    this.deduplicationClassDialogVisible = true;
    this.deduplicationClassMode = mode;
  }
  settingClassChange(item: any) {
    QuestionnaireEditModule.SET_BASIC_DATA_REPEATEDCLASSNAME(item.settingName);
    QuestionnaireEditModule.SET_BASIC_DATA_REPEATEDCLASSID(item.id);
  }
  /////////////////////

  private mounted() {
    // this.cmpsData = questionData;
  }
  ////////////////////////
  //选择问卷模板
  surveyTemplateSelectDialogVisible = false;
  surveyTemplateSelectSuccess(questionnaireId: String) {
    console.log("surveyTemplateSelectSuccess", questionnaireId);
    this.$emit("refreshQuestionnaireId", questionnaireId);
  }
  //////////////////////
  configMode = "all";
  configModeChange(mode: any) {
    this.configMode == mode;
  }
  getModulesConfigInstance() {
    return this.$refs.modulesConfig as any;
  }
  async CHECK_DATA_validate() {
    try {
      let result: { valid: boolean; index: number } = await this.getModulesConfigInstance().validate();

      if (result.valid) {
        let totalScore = 0;
        this.dataList.forEach((element: any) => {
          totalScore += Number(element.data.itemScore) || 0;
        });
        QuestionnaireEditModule.SET_TOTALSCORE_DATA(totalScore as number);
      }

      const logicResult = await this.getModulesConfigInstance().validatLogicSetData();
      if (!logicResult) {
        this.$message.warning("请检查规则设置");
        // this.$notify.error({
        //   title: "规则设置",
        //   message: "请检查规则设置",
        // });
      }
      let auditLogicResult = true;
      if (QuestionnaireEditModule.showVerifactionConfig) {
        auditLogicResult = await this.getModulesConfigInstance().validatAuditLogicSetData();

        if (!auditLogicResult) {
          this.$message.warning("请检查审核设置");
          // this.$notify.error({
          //   title: "审核设置",
          //   message: "请检查审核设置",
          // });
        }
      }

      const repeatedCheckError = this.participateRepeatedCheck && !this.participateRepeatedClassId;
      if (repeatedCheckError) {
        this.$message.warning("请填写排重设置");
        // this.$notify.error({
        //   title: "排重设置",
        //   message: "请填写排重设置",
        // });
      }
      return result.valid && logicResult && auditLogicResult && !repeatedCheckError;
    } catch (error) {
      console.log("CHECK_DATA_validateerror", error);
      return false;
    }
  }
}
